import React, { useEffect, useState, createElement } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Check, ArrowRight, AlertTriangle, BookOpen, Clock, ShieldCheck, Star, Menu, X } from 'lucide-react';
import { PurchaseNotification } from '../components/PurchaseNotification';
import { TestimonialCard } from '../components/TestimonialCard';
import { BonusCard } from '../components/BonusCard';
import { ProductCarousel } from '../components/ProductCarousel';
import { FAQItem } from '../components/FAQItem';
const CHECKOUT_URL = 'https://checkout.rincondigital.shop/cart/52921014223123:1';
const MEGAPACK_URL = 'https://checkout.rincondigital.shop/cart/52921028411667:1';
export function LandingPage() {
  const [showStickyCTA, setShowStickyCTA] = useState(false);
  const {
    scrollY
  } = useScroll();
  // Meta Pixel tracking
  useEffect(() => {
    // Initialize Meta Pixel
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('init', '1904779843432668');
      (window as any).fbq('track', 'PageView');
    } else {
      // Load Meta Pixel script if not already loaded
      const script = document.createElement('script');
      script.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '1904779843432668');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(script);
      // Add noscript pixel
      const noscript = document.createElement('noscript');
      noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1904779843432668&ev=PageView&noscript=1" />`;
      document.body.appendChild(noscript);
    }
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      setShowStickyCTA(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToPurchase = () => {
    const element = document.getElementById('purchase-section');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900 overflow-x-hidden" data-id="element-41">
      <PurchaseNotification data-id="element-42" />

      {/* Sticky CTA */}
      <motion.div initial={{
      y: 100
    }} animate={{
      y: showStickyCTA ? 0 : 100
    }} className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-gray-200 shadow-[0_-4px_20px_rgba(0,0,0,0.1)] p-4 md:hidden" data-id="element-43">
        <button onClick={scrollToPurchase} className="w-full bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-bold py-3 px-6 rounded-xl shadow-lg hover:shadow-xl transition-all active:scale-95 flex items-center justify-center gap-2" data-id="element-44">
          Conseguir NTICX 360
          <ArrowRight className="w-5 h-5" data-id="element-45" />
        </button>
      </motion.div>

      <motion.div initial={{
      y: -100
    }} animate={{
      y: showStickyCTA ? 0 : -100
    }} className="fixed top-0 left-0 right-0 z-40 bg-white/90 backdrop-blur-md border-b border-gray-200 shadow-sm py-3 px-6 hidden md:flex justify-between items-center" data-id="element-46">
        <span className="font-bold text-xl bg-clip-text text-transparent bg-gradient-to-r from-indigo-600 to-purple-600" data-id="element-47">
          NTICX 360
        </span>
        <button onClick={scrollToPurchase} className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-bold py-2 px-6 rounded-full shadow-md hover:shadow-lg transition-all hover:-translate-y-0.5" data-id="element-48">
          Conseguir Acceso Ahora
        </button>
      </motion.div>

      {/* Hero Section */}
      <header className="relative bg-[#0f172a] text-white overflow-hidden" data-id="element-49">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1550751827-4bd374c3f58b?q=80&w=2070&auto=format&fit=crop')] bg-cover bg-center opacity-10 mix-blend-overlay" data-id="element-50"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-indigo-900/50 to-[#0f172a]" data-id="element-51"></div>

        <div className="container mx-auto px-4 py-12 md:py-20 relative z-10" data-id="element-52">
          <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-53">
            <div className="w-full md:w-1/2 space-y-6 text-center md:text-left" data-id="element-54">
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6
            }} data-id="element-55">
                <span className="inline-block px-4 py-1 rounded-full bg-indigo-500/20 border border-indigo-400/30 text-indigo-300 text-sm font-semibold mb-4" data-id="element-56">
                  Para Docentes de Secundaria
                </span>
                <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight tracking-tight mb-6" data-id="element-57">
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 via-purple-400 to-orange-400" data-id="element-58">
                    NTICX
                  </span>{' '}
                  no es el problema
                </h1>
                <p className="text-xl md:text-2xl text-gray-300 font-light leading-relaxed" data-id="element-59">
                  El problema es cómo nos obligaron a enseñarla. <br data-id="element-60" />
                  <span className="font-semibold text-white" data-id="element-61">
                    Clases listas para todo el año.
                  </span>
                </p>
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6,
              delay: 0.2
            }} className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start pt-4" data-id="element-62">
                <button onClick={scrollToPurchase} className="bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white text-lg font-bold py-4 px-8 rounded-xl shadow-lg shadow-orange-500/30 transition-all hover:scale-105 active:scale-95 flex items-center justify-center gap-2" data-id="element-63">
                  Quiero mis clases listas
                  <ArrowRight className="w-5 h-5" data-id="element-64" />
                </button>
              </motion.div>
            </div>

            <div className="w-full md:w-1/2" data-id="element-65">
              <motion.div initial={{
              opacity: 0,
              scale: 0.9,
              rotate: -2
            }} animate={{
              opacity: 1,
              scale: 1,
              rotate: 0
            }} transition={{
              duration: 0.8,
              type: 'spring'
            }} className="relative" data-id="element-66">
                <div className="absolute -inset-4 bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl blur-2xl opacity-40 animate-pulse" data-id="element-67"></div>
                <img src="https://cdn.magicpatterns.com/uploads/fwmvgkWs9j96BSgKGKx4Dr/COVER_NTICX360.png" alt="NTICX 360 Cover" className="relative rounded-2xl shadow-2xl border border-white/10 w-full hover:scale-[1.02] transition-transform duration-500" data-id="element-68" />
              </motion.div>
            </div>
          </div>
        </div>
      </header>

      {/* Problem Section */}
      <section className="py-20 px-4 bg-white" data-id="element-69">
        <div className="container mx-auto max-w-4xl" data-id="element-70">
          <div className="text-center mb-16" data-id="element-71">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-72">
              NTICX está en todos lados.
            </h2>
            <p className="text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto" data-id="element-73">
              En los celulares. En las redes. En la información que consumen tus
              alumnos todos los días. Y sin embargo, cuando llega la hora de dar
              NTICX en el aula, pasa siempre lo mismo:
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-74">
            <div className="bg-red-50 p-8 rounded-2xl border border-red-100" data-id="element-75">
              <h3 className="text-xl font-bold text-red-700 mb-6 flex items-center gap-2" data-id="element-76">
                <AlertTriangle className="w-6 h-6" data-id="element-77" />
                La realidad del aula
              </h3>
              <ul className="space-y-4" data-id="element-78">
                {['Contenidos desordenados', 'Programas poco claros o cambiantes', 'Clases armadas a último momento', 'Alumnos desconectados', 'Docentes agotados'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-700" data-id="element-79">
                    <span className="w-6 h-6 rounded-full bg-red-200 text-red-700 flex items-center justify-center flex-shrink-0 text-sm font-bold" data-id="element-80">
                      ✕
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="flex flex-col justify-center space-y-6" data-id="element-81">
              <p className="text-lg text-gray-800 font-medium" data-id="element-82">
                No porque no sepas enseñar. No porque no te importe.
              </p>
              <p className="text-2xl font-bold text-indigo-900" data-id="element-83">
                Sino porque nadie te dio una estructura real para enseñar NTICX.
              </p>
            </div>
          </div>

          <div className="bg-slate-900 text-white p-8 md:p-12 rounded-3xl shadow-xl relative overflow-hidden" data-id="element-84">
            <div className="absolute top-0 right-0 w-64 h-64 bg-indigo-500 rounded-full blur-3xl opacity-20 -translate-y-1/2 translate-x-1/2" data-id="element-85"></div>
            <h3 className="text-2xl font-bold mb-8 relative z-10" data-id="element-86">
              Si sos docente de NTICX y alguna vez pensaste...
            </h3>
            <div className="grid md:grid-cols-2 gap-6 relative z-10" data-id="element-87">
              {['“Siento que esta materia es un caos”', '“Otra vez voy a improvisar”', '“No sé si esto está bien armado”', '“Mis alumnos no conectan”', '“Planificar NTICX me consume la cabeza”'].map((quote, i) => <div key={i} className="bg-white/10 backdrop-blur-sm p-4 rounded-xl border border-white/10 italic" data-id="element-88">
                  {quote}
                </div>)}
            </div>
            <div className="mt-8 text-center relative z-10" data-id="element-89">
              <p className="text-xl font-bold text-orange-400" data-id="element-90">
                Esto es para vos.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Agitation / Scenario */}
      <section className="py-20 px-4 bg-gray-50 border-y border-gray-200" data-id="element-91">
        <div className="container mx-auto max-w-3xl text-center" data-id="element-92">
          <div className="inline-flex items-center justify-center p-3 bg-indigo-100 rounded-full mb-8" data-id="element-93">
            <Clock className="w-8 h-8 text-indigo-600" data-id="element-94" />
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-95">
            El momento que todos los docentes conocen
          </h2>

          <div className="prose prose-lg mx-auto text-gray-600" data-id="element-96">
            <p className="mb-6" data-id="element-97">
              Domingo a la noche. Abrís la notebook. Pensás:{' '}
              <span className="font-bold text-gray-900" data-id="element-98">
                "¿Qué doy mañana?"
              </span>
            </p>
            <p className="mb-6" data-id="element-99">
              Buscás PDFs. PowerPoints viejos. Videos que más o menos encajan.
              Armás algo… y cruzás los dedos.
            </p>
            <p className="text-xl font-medium text-indigo-900 bg-indigo-50 p-6 rounded-xl border border-indigo-100" data-id="element-100">
              Eso no es falta de capacidad. Eso es falta de sistema.
            </p>
          </div>
        </div>
      </section>

      {/* Solution Section */}
      <section className="py-20 px-4 bg-white overflow-hidden" data-id="element-101">
        <div className="container mx-auto max-w-6xl" data-id="element-102">
          <div className="flex flex-col md:flex-row items-center gap-16" data-id="element-103">
            <div className="w-full md:w-1/2 order-2 md:order-1" data-id="element-104">
              <div className="relative" data-id="element-105">
                <div className="absolute inset-0 bg-gradient-to-tr from-blue-500 to-purple-500 rounded-full blur-3xl opacity-20" data-id="element-106"></div>
                <img src="https://cdn.magicpatterns.com/uploads/fwmvgkWs9j96BSgKGKx4Dr/COVER_NTICX360.png" alt="NTICX 360 Product" className="relative rounded-2xl shadow-2xl hover:scale-105 transition-transform duration-500" data-id="element-107" />
              </div>
            </div>

            <div className="w-full md:w-1/2 order-1 md:order-2" data-id="element-108">
              <span className="text-indigo-600 font-bold tracking-wider uppercase text-sm" data-id="element-109">
                La buena noticia
              </span>
              <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mt-2 mb-6" data-id="element-110">
                Presentamos:{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600" data-id="element-111">
                  NTICX 360
                </span>
              </h2>

              <p className="text-lg text-gray-700 mb-6" data-id="element-112">
                Un sistema completo de clases listas de NTICX para todo el año,
                pensado para docentes reales, aulas reales y alumnos reales.
              </p>

              <p className="text-lg text-gray-700 mb-8 font-medium" data-id="element-113">
                NTICX 360 no es material suelto. Es un recorrido anual cerrado,
                listo para usar.
              </p>

              <div className="bg-gray-50 p-6 rounded-2xl border border-gray-100 mb-8" data-id="element-114">
                <h3 className="font-bold text-gray-900 mb-4 flex items-center gap-2" data-id="element-115">
                  <BookOpen className="w-5 h-5 text-indigo-600" data-id="element-116" />
                  ¿Qué incluye NTICX 360?
                </h3>
                <ul className="space-y-3" data-id="element-117">
                  {['Clases secuenciadas de menor a mayor complejidad', 'Explicaciones claras en lenguaje docente', 'Actividades pensadas para el aula real', 'Contenidos actuales y aplicables', 'Enfoque práctico (no teoría pesada)'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-118">
                      <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-119" />
                      <span className="text-gray-700" data-id="element-120">{item}</span>
                    </li>)}
                </ul>
              </div>

              <button onClick={scrollToPurchase} className="w-full md:w-auto bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-3 px-8 rounded-xl shadow-lg transition-colors flex items-center justify-center gap-2" data-id="element-121">
                Ver Oferta Especial
                <ArrowRight className="w-5 h-5" data-id="element-122" />
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Differentiation */}
      <section className="py-20 px-4 bg-slate-900 text-white" data-id="element-123">
        <div className="container mx-auto max-w-4xl text-center" data-id="element-124">
          <h2 className="text-3xl md:text-4xl font-bold mb-12" data-id="element-125">
            ¿Por qué es diferente?
          </h2>

          <div className="grid md:grid-cols-2 gap-12 items-center mb-16" data-id="element-126">
            <div className="text-left space-y-6" data-id="element-127">
              <p className="text-xl text-gray-300" data-id="element-128">
                Porque no fue creado como un libro. <br data-id="element-129" />
                <span className="text-white font-bold text-2xl" data-id="element-130">
                  Fue creado desde el aula.
                </span>
              </p>
              <p className="text-lg text-gray-400" data-id="element-131">
                NTICX 360 responde a la pregunta que nadie te contestó:
                <br data-id="element-132" />
                <span className="text-indigo-400 italic" data-id="element-133">
                  "¿Qué doy, en qué orden y cómo lo explico para que funcione?"
                </span>
              </p>
            </div>

            <div className="bg-white/5 p-8 rounded-2xl border border-white/10 text-left" data-id="element-134">
              <h3 className="font-bold text-xl mb-6 text-orange-400" data-id="element-135">
                Con NTICX 360 vas a lograr:
              </h3>
              <ul className="space-y-4" data-id="element-136">
                {['Entrar al aula con seguridad', 'Tener el año completo ordenado', 'Dejar de improvisar', 'Explicar tecnología con claridad', 'Ahorrar horas de planificación', 'Disfrutar más la materia'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-137">
                    <div className="w-6 h-6 rounded-full bg-green-500/20 text-green-400 flex items-center justify-center flex-shrink-0" data-id="element-138">
                      <Check className="w-4 h-4" data-id="element-139" />
                    </div>
                    <span data-id="element-140">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="bg-gradient-to-r from-indigo-900 to-blue-900 p-8 rounded-2xl border border-indigo-500/30" data-id="element-141">
            <h3 className="text-2xl font-bold mb-4" data-id="element-142">Pensalo así</h3>
            <div className="grid md:grid-cols-2 gap-8 text-left" data-id="element-143">
              <div className="bg-black/20 p-6 rounded-xl" data-id="element-144">
                <p className="text-red-300 font-medium mb-2" data-id="element-145">
                  NTICX sin estructura
                </p>
                <p className="text-gray-300" data-id="element-146">
                  Es como Google Maps sin ruta. Tenés información, pero no sabés
                  por dónde ir.
                </p>
              </div>
              <div className="bg-indigo-500/20 p-6 rounded-xl border border-indigo-500/50" data-id="element-147">
                <p className="text-green-300 font-bold mb-2" data-id="element-148">NTICX 360</p>
                <p className="text-white" data-id="element-149">
                  Es como tener el año ya resuelto en la cabeza. Vos solo
                  entrás… y das la clase.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="py-20 px-4 bg-gradient-to-b from-gray-50 to-white" data-id="element-150">
        <div className="container mx-auto max-w-6xl" data-id="element-151">
          <div className="text-center mb-16" data-id="element-152">
            <span className="inline-block bg-yellow-400 text-black font-bold px-4 py-1 rounded-full text-sm mb-4 animate-bounce" data-id="element-153">
              OFERTA LIMITADA
            </span>
            <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900" data-id="element-154">
              Bonos <span className="text-red-600" data-id="element-155">GRATIS</span> por el día de
              hoy
            </h2>
            <p className="text-xl text-gray-600 mt-4" data-id="element-156">
              Llevate todo esto de regalo al acceder hoy mismo
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-157">
            <BonusCard imageUrl="https://cdn.magicpatterns.com/uploads/pXKkXpMjs8ZwcyCR4rU547/BONUS_1_NTICX.png" title="Bonus 1: Clases Salvavidas" onClick={scrollToPurchase} data-id="element-158" />
            <BonusCard imageUrl="https://cdn.magicpatterns.com/uploads/837HkVEpEmvvp6MSYCmm1T/BONUS_2_NTICX.png" title="Bonus 2: Evaluaciones + Rúbricas" onClick={scrollToPurchase} data-id="element-159" />
            <BonusCard imageUrl="https://cdn.magicpatterns.com/uploads/bWfkuu4iMqp7qnHE5xQN2A/BONUS_3_NTICS.png" title="Bonus 3: Mapa Anual de Contenidos" onClick={scrollToPurchase} data-id="element-160" />
          </div>
        </div>
      </section>

      {/* Final CTA / Pricing */}
      <section id="purchase-section" className="py-24 px-4 bg-gradient-to-br from-indigo-900 via-purple-900 to-slate-900 text-white relative overflow-hidden" data-id="element-161">
        {/* Background effects */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-162">
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-blue-500 rounded-full blur-[100px] opacity-30" data-id="element-163"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-purple-500 rounded-full blur-[100px] opacity-30" data-id="element-164"></div>
        </div>

        <div className="container mx-auto max-w-2xl relative z-10" data-id="element-165">
          {/* Main Offer Card */}
          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-2xl" data-id="element-166">
            {/* Product Image */}
            <div className="mb-8" data-id="element-167">
              <img src="https://cdn.magicpatterns.com/uploads/fwmvgkWs9j96BSgKGKx4Dr/COVER_NTICX360.png" alt="NTICX 360 - Clases listas para todo el año" className="w-full rounded-2xl shadow-xl" data-id="element-168" />
            </div>

            {/* Pricing */}
            <div className="text-center mb-10" data-id="element-169">
              <p className="text-gray-500 text-sm uppercase tracking-wider mb-2" data-id="element-170">
                PRECIO FINAL
              </p>
              <div className="flex items-center justify-center gap-4 mb-2" data-id="element-171">
                <span className="text-2xl text-gray-400 line-through" data-id="element-172">
                  $49.990
                </span>
                <span className="text-5xl md:text-6xl font-extrabold text-indigo-900" data-id="element-173">
                  $19.990
                </span>
              </div>
              <div className="inline-flex items-center gap-2 bg-green-100 text-green-700 px-4 py-1 rounded-full text-sm font-bold" data-id="element-174">
                <Clock className="w-4 h-4" data-id="element-175" />
                Bonos gratis solo por hoy
              </div>
            </div>

            {/* Feature Boxes */}
            <div className="space-y-4 mb-8" data-id="element-176">
              {/* Box 1 - Main Product */}
              <div className="bg-green-50 border border-green-100 rounded-2xl p-6" data-id="element-177">
                <div className="flex items-start gap-4" data-id="element-178">
                  <div className="w-8 h-8 rounded-full bg-green-500 flex items-center justify-center flex-shrink-0" data-id="element-179">
                    <Check className="w-5 h-5 text-white" data-id="element-180" />
                  </div>
                  <div data-id="element-181">
                    <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-182">
                      Sistema Completo NTICX 360
                    </h3>
                    <p className="text-gray-700 text-sm leading-relaxed" data-id="element-183">
                      Clases estructuradas para todo el año lectivo con ejemplos
                      argentinos actuales. Secuenciadas de menor a mayor
                      complejidad.
                    </p>
                  </div>
                </div>
              </div>

              {/* Box 2 - Bonuses */}
              <div className="bg-orange-50 border border-orange-100 rounded-2xl p-6" data-id="element-184">
                <div className="flex items-start gap-4" data-id="element-185">
                  <div className="w-8 h-8 rounded-full bg-orange-500 flex items-center justify-center flex-shrink-0" data-id="element-186">
                    <Check className="w-5 h-5 text-white" data-id="element-187" />
                  </div>
                  <div data-id="element-188">
                    <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-189">
                      3 Bonos Exclusivos (Gratis por hoy)
                    </h3>
                    <p className="text-gray-700 text-sm leading-relaxed" data-id="element-190">
                      Clases salvavidas, evaluaciones con rúbricas y mapa anual
                      de contenidos completo.
                    </p>
                  </div>
                </div>
              </div>

              {/* Box 3 - Access */}
              <div className="bg-blue-50 border border-blue-100 rounded-2xl p-6" data-id="element-191">
                <div className="flex items-start gap-4" data-id="element-192">
                  <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center flex-shrink-0" data-id="element-193">
                    <Check className="w-5 h-5 text-white" data-id="element-194" />
                  </div>
                  <div data-id="element-195">
                    <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-196">
                      Acceso Inmediato y Vitalicio
                    </h3>
                    <p className="text-gray-700 text-sm leading-relaxed" data-id="element-197">
                      Descargá todo el material al instante y accedé cuando lo
                      necesites, sin vencimiento.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* CTA Button */}
            <a href={CHECKOUT_URL} className="block w-full bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white text-xl font-bold py-5 px-8 rounded-2xl shadow-xl shadow-orange-500/30 transition-all hover:scale-105 active:scale-95 text-center group mb-6" data-id="element-198">
              <span className="flex items-center justify-center gap-2" data-id="element-199">
                ACCEDÉ AHORA Y EMPEZÁ A ENSEÑAR
                <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-200" />
              </span>
            </a>

            {/* Trust Badges */}
            <div className="flex items-center justify-center gap-6 text-sm text-gray-600" data-id="element-201">
              <div className="flex items-center gap-2" data-id="element-202">
                <ShieldCheck className="w-5 h-5 text-green-600" data-id="element-203" />
                <span data-id="element-204">Compra Segura</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-205">
                <BookOpen className="w-5 h-5 text-indigo-600" data-id="element-206" />
                <span data-id="element-207">Material Digital</span>
              </div>
            </div>
          </div>

          {/* Upsell Section - Megapack */}
          <div className="mt-8 bg-white rounded-3xl p-8 md:p-12 shadow-2xl border-4 border-orange-400" data-id="element-208">
            {/* Special Offer Badge */}
            <div className="flex justify-center mb-6" data-id="element-209">
              <span className="inline-flex items-center gap-2 bg-gradient-to-r from-orange-500 to-red-500 text-white font-bold px-6 py-2 rounded-full text-sm shadow-lg" data-id="element-210">
                🔥 OFERTA ESPECIAL - PACK FULL
              </span>
            </div>

            {/* Title */}
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-4" data-id="element-211">
              SIC 360, MICRO Y MACRO ECONOMÍA 360 + NTICX 360
            </h3>
            <p className="text-center text-gray-600 mb-8 max-w-2xl mx-auto" data-id="element-212">
              Llevate el megapack completo de secundario comercial contable con
              clases listas resueltas para todo el año
            </p>

            {/* Product Carousel */}
            <div className="mb-8 max-w-md mx-auto" data-id="element-213">
              <ProductCarousel images={['https://cdn.magicpatterns.com/uploads/roq1nnq65pCAFFGkqNVEBz/Cover_SIC_360.png', 'https://cdn.magicpatterns.com/uploads/d9hieKhAvWwwA4bFhgHY7B/conver_micro_y_macro.png', 'https://cdn.magicpatterns.com/uploads/vAjC6U4gtizFwmK7RCkF6j/COVER_NTICX360.png']} data-id="element-214" />
            </div>

            {/* Pricing */}
            <div className="text-center mb-10" data-id="element-215">
              <p className="text-gray-500 text-sm uppercase tracking-wider mb-2" data-id="element-216">
                PRECIO PACK COMPLETO
              </p>
              <div className="flex items-center justify-center gap-4 mb-2" data-id="element-217">
                <span className="text-2xl text-gray-400 line-through" data-id="element-218">
                  $79.990
                </span>
                <span className="text-5xl md:text-6xl font-extrabold text-indigo-900" data-id="element-219">
                  $49.990
                </span>
              </div>
              <p className="text-green-600 font-bold text-lg" data-id="element-220">
                Ahorrás $30.000 con el pack completo
              </p>
            </div>

            {/* Feature Boxes */}
            <div className="space-y-4 mb-8" data-id="element-221">
              {/* Box 1 - Sistema Completo SIC 360 */}
              <div className="bg-green-50 border border-green-100 rounded-2xl p-6" data-id="element-222">
                <div className="flex items-start gap-4" data-id="element-223">
                  <div className="w-8 h-8 rounded-full bg-green-500 flex items-center justify-center flex-shrink-0" data-id="element-224">
                    <Check className="w-5 h-5 text-white" data-id="element-225" />
                  </div>
                  <div data-id="element-226">
                    <h4 className="text-lg font-bold text-gray-900 mb-2" data-id="element-227">
                      Sistema Completo SIC 360
                    </h4>
                    <p className="text-gray-700 text-sm leading-relaxed" data-id="element-228">
                      Clases estructuradas para todo el año lectivo con ejemplos
                      argentinos actuales
                    </p>
                  </div>
                </div>
              </div>

              {/* Box 2 - Bonuses */}
              <div className="bg-orange-50 border border-orange-100 rounded-2xl p-6" data-id="element-229">
                <div className="flex items-start gap-4" data-id="element-230">
                  <div className="w-8 h-8 rounded-full bg-orange-500 flex items-center justify-center flex-shrink-0" data-id="element-231">
                    <Check className="w-5 h-5 text-white" data-id="element-232" />
                  </div>
                  <div data-id="element-233">
                    <h4 className="text-lg font-bold text-gray-900 mb-2" data-id="element-234">
                      4 Bonos Exclusivos (Gratis por hoy)
                    </h4>
                    <p className="text-gray-700 text-sm leading-relaxed" data-id="element-235">
                      Banco de ejemplos, clases express, evaluaciones listas y
                      mapa anual de contenidos
                    </p>
                  </div>
                </div>
              </div>

              {/* Box 3 - Access */}
              <div className="bg-blue-50 border border-blue-100 rounded-2xl p-6" data-id="element-236">
                <div className="flex items-start gap-4" data-id="element-237">
                  <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center flex-shrink-0" data-id="element-238">
                    <Check className="w-5 h-5 text-white" data-id="element-239" />
                  </div>
                  <div data-id="element-240">
                    <h4 className="text-lg font-bold text-gray-900 mb-2" data-id="element-241">
                      Acceso Inmediato y Vitalicio
                    </h4>
                    <p className="text-gray-700 text-sm leading-relaxed" data-id="element-242">
                      Descargá todo el material al instante y accedé cuando lo
                      necesites, sin vencimiento
                    </p>
                  </div>
                </div>
              </div>

              {/* Box 4 - EXTRA (Yellow Highlight) */}
              <div className="bg-gradient-to-r from-yellow-50 to-orange-50 border-2 border-yellow-400 rounded-2xl p-6 relative overflow-hidden" data-id="element-243">
                <div className="absolute top-2 right-2 bg-yellow-400 text-yellow-900 text-xs font-bold px-3 py-1 rounded-full" data-id="element-244">
                  EXTRA
                </div>
                <div className="flex items-start gap-4" data-id="element-245">
                  <div className="w-8 h-8 rounded-full bg-yellow-500 flex items-center justify-center flex-shrink-0" data-id="element-246">
                    <Check className="w-5 h-5 text-white" data-id="element-247" />
                  </div>
                  <div data-id="element-248">
                    <h4 className="text-lg font-bold text-gray-900 mb-2" data-id="element-249">
                      MICRO Y MACRO ECONOMÍA 360 + SIC 360
                    </h4>
                    <p className="text-gray-700 text-sm leading-relaxed" data-id="element-250">
                      Megapack comercial contable con clases resueltas para todo
                      el año
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* CTA Button */}
            <a href={MEGAPACK_URL} className="block w-full bg-gradient-to-r from-yellow-500 to-orange-500 hover:from-yellow-600 hover:to-orange-600 text-white text-xl font-bold py-5 px-8 rounded-2xl shadow-xl shadow-orange-500/30 transition-all hover:scale-105 active:scale-95 text-center group mb-6" data-id="element-251">
              <span className="flex items-center justify-center gap-2" data-id="element-252">
                ACCEDÉ AL MEGAPACK COMERCIAL CONTABLE 360
                <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-253" />
              </span>
            </a>

            {/* Trust Badges */}
            <div className="flex items-center justify-center gap-6 text-sm text-gray-600" data-id="element-254">
              <div className="flex items-center gap-2" data-id="element-255">
                <ShieldCheck className="w-5 h-5 text-green-600" data-id="element-256" />
                <span data-id="element-257">Compra Segura</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-258">
                <BookOpen className="w-5 h-5 text-indigo-600" data-id="element-259" />
                <span data-id="element-260">Material Digital</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Guarantee Section */}
      <section className="py-20 px-4 bg-gradient-to-br from-indigo-900 via-purple-900 to-slate-900 border-t border-white/10" data-id="element-261">
        <div className="container mx-auto max-w-4xl text-center" data-id="element-262">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-orange-500/20 rounded-full mb-8" data-id="element-263">
            <ShieldCheck className="w-10 h-10 text-orange-400" data-id="element-264" />
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-265">
            Garantía sin vueltas
          </h2>

          <div className="space-y-6 text-lg text-gray-300 max-w-3xl mx-auto" data-id="element-266">
            <p className="leading-relaxed" data-id="element-267">
              Estamos tan seguros de que NTICX 360 te va a transformar la forma
              de enseñar, que si no es así,{' '}
              <span className="text-white font-bold" data-id="element-268">
                te devolvemos el 100% de tu dinero.
              </span>
            </p>
            <p className="leading-relaxed" data-id="element-269">
              Tenés <span className="text-orange-400 font-bold" data-id="element-270">7 días</span>{' '}
              para probarlo sin riesgo. Si no te convence, nos escribís y te
              hacemos el reembolso.
              <span className="text-white font-semibold" data-id="element-271"> Así de simple.</span>
            </p>
          </div>
        </div>
      </section>

      {/* Testimonials - Moved Here */}
      <section className="py-20 px-4 bg-white" data-id="element-272">
        <div className="container mx-auto max-w-6xl" data-id="element-273">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-16" data-id="element-274">
            Lo que dicen otros docentes
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-275">
            <TestimonialCard name="María Elena Rodríguez" age={45} role="Profesora de NTICX" location="Córdoba" quote="Finalmente puedo planificar NTICX sin estrés. Las clases están listas y mis alumnos están más conectados que nunca." data-id="element-276" />
            <TestimonialCard name="Javier Martínez" age={38} role="Docente de Tecnología" location="Buenos Aires" quote="NTICX 360 me salvó el año. Ya no improviso y tengo todo el programa cubierto con claridad." data-id="element-277" />
            <TestimonialCard name="Carolina Fernández" age={42} role="Profesora de Informática" location="Rosario" quote="Antes pasaba horas buscando material. Ahora entro al aula segura y con todo preparado." data-id="element-278" />
            <TestimonialCard name="Roberto Sánchez" age={51} role="Docente de NTICX" location="Mendoza" quote="Llevo 20 años enseñando y este es el recurso más completo que encontré para NTICX." data-id="element-279" />
            <TestimonialCard name="Lucía Gómez" age={36} role="Profesora de Tecnología" location="La Plata" quote="Mis clases ahora tienen estructura real. Los alumnos notan la diferencia y yo también." data-id="element-280" />
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 px-4 bg-gray-50" data-id="element-281">
        <div className="container mx-auto max-w-3xl" data-id="element-282">
          <div className="text-center mb-12" data-id="element-283">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-284">
              Resolvé aquí tus DUDAS
            </h2>
            <p className="text-xl text-gray-600" data-id="element-285">
              Las preguntas más frecuentes sobre el pack
            </p>
          </div>

          <div className="space-y-4" data-id="element-286">
            <FAQItem question="¿Qué recibo al comprar el Kit?" answer="Recibís acceso inmediato a todas las clases de NTICX 360 estructuradas para todo el año lectivo, más los 3 bonos exclusivos: Clases Salvavidas, Evaluaciones con Rúbricas y Mapa Anual de Contenidos. Todo en formato digital, listo para descargar y usar." data-id="element-287" />
            <FAQItem question="¿Cuándo me llega?" answer="El acceso es inmediato. Apenas completás la compra, recibís un email con tus credenciales de acceso y podés empezar a descargar todo el material al instante." data-id="element-288" />
            <FAQItem question="¿Cómo lo recibo?" answer="Te llega por email un link de acceso a tu área de miembros donde encontrás todo el material organizado y listo para descargar. Podés acceder desde cualquier dispositivo (computadora, tablet o celular)." data-id="element-289" />
            <FAQItem question="¿Es físico o digital?" answer="Es 100% digital. Esto te permite acceder al instante, desde cualquier lugar, y descargar todo el material en formato PDF editable para adaptarlo a tus necesidades." data-id="element-290" />
            <FAQItem question="¿Necesito ser profesional?" answer="No necesitás ser especialista en tecnología. NTICX 360 está diseñado para docentes de cualquier área que dicten la materia. Las explicaciones son claras y en lenguaje docente, sin tecnicismos innecesarios." data-id="element-291" />
            <FAQItem question="¿Tengo acceso para siempre?" answer="Sí, el acceso es vitalicio. Una vez que comprás, el material es tuyo para siempre. Podés descargarlo, guardarlo y usarlo todos los años que quieras, sin vencimiento ni renovaciones." data-id="element-292" />
            <FAQItem question="¿Qué hago si no me llega el acceso?" answer="Si no te llega el email en los próximos 5 minutos, revisá tu carpeta de spam o promociones. Si aún no lo encontrás, escribinos a soporte y te lo reenviamos al instante." data-id="element-293" />
            <FAQItem question="¿Es una compra segura?" answer="Sí, totalmente segura. Usamos la plataforma de pagos más confiable de Argentina con encriptación SSL. Además, tenés garantía de devolución de 7 días si no te convence el material." data-id="element-294" />
          </div>

          {/* Final CTA */}
          <div className="mt-12 text-center" data-id="element-295">
            <button onClick={scrollToPurchase} className="inline-flex items-center justify-center bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white text-xl font-bold py-5 px-12 rounded-2xl shadow-xl transition-all hover:scale-105 active:scale-95 group" data-id="element-296">
              Quiero acceder ahora sin riesgo
              <ArrowRight className="w-6 h-6 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-297" />
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-950 text-gray-500 py-12 px-4 text-center text-sm" data-id="element-298">
        <div className="container mx-auto" data-id="element-299">
          <p className="mb-4" data-id="element-300">
            © {new Date().getFullYear()} NTICX 360. Todos los derechos
            reservados.
          </p>
          <p data-id="element-301">
            Este sitio no forma parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </div>;
}